import React from 'react';
import PropTypes from 'prop-types';

import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText, Stack,
} from '../../../ui';
import AnimatedCircleCountdown from '../../../ui/AnimatedCircleCountdown';
import Button from '../../../ui/Button';

const SearchBoostNotification = ({
  bottom,
  bottomEmphasize,
  buttonText,
  eventName,
  link,
  linkParams,
  notification,
  sent,
  top,
  topEmphasize,
}) => {
  const {
    providerId,
    daysLeft,
  } = notification;

  const elapsed = 7 - daysLeft;

  return (
    <Stack
      space={8}
      paddingTop={16}
      justifyContent="flex-end"
      paddingRight={20}
    >
      <Inline
        space={8}
        justifyContent="space-around"
        paddingLeft={12}
      >
        <Stack alignItems="center" style={{ width: 48 }}>
          <AnimatedCircleCountdown elapsed={elapsed} max={7} width={34} />
          <BodyText
            appearance="smaller"
            color={colors.slate}
            textAlign="center"
            weight="normal"
          >
            Day{daysLeft === 1 ? null : 's'} left in search boost
          </BodyText>
        </Stack>
        <Stack
          space={8}
          style={{ width: 'calc(100% - 65px)' }}
        >
          <BodyText
            appearance="small"
            weight="normal"
            color={colors.blackInBlack}
          >
            {topEmphasize && (
              <BodyText
                appearance="small"
                weight="bold"
                color={colors.blackInBlack}
                style={{
                  marginRight: '5px',
                }}
              >
                {topEmphasize}
              </BodyText>
            )}
            {top}
          </BodyText>
          <BodyText
            appearance="small"
            color={colors.silver}
          >
            {sent}
          </BodyText>
          <Stack
            paddingRight={8}
            paddingLeft={8}
            borderStyle="solid"
            borderColor={colors.petal}
            borderLeftWidth={4}
          >
            <BodyText
              appearance="small"
              weight="normal"
              color={colors.blackInBlack}
            >
              {bottomEmphasize && (
                <BodyText
                  appearance="small"
                  weight="bold"
                  color={colors.blackInBlack}
                  style={{
                    marginRight: '5px',
                  }}
                >
                  {bottomEmphasize}
                </BodyText>
              )}
              {bottom}
            </BodyText>
          </Stack>

        </Stack>
      </Inline>
      <Box
        paddingBottom={8}
        borderColor={colors.lightGrey}
        borderStyle="solid"
        borderBottomWidth={1}
        style={{
          width: '100%',
          marginLeft: '75px',
        }}
      >
        <Button
          text={buttonText}
          appearance="text-light"
          size="small"
          style={{
            alignSelf: 'flex-start',
          }}
          link={link}
          linkParams={linkParams}
          clickTracking={{
            name: eventName,
            params: {
              days_left_in_boost: daysLeft,
              provider_id: providerId,
            },
          }}
        />
      </Box>

    </Stack>
  );
};

SearchBoostNotification.propTypes = {
  bottom: PropTypes.string,
  bottomEmphasize: PropTypes.string,
  buttonText: PropTypes.string,
  eventName: PropTypes.string,
  notification: PropTypes.shape({
    providerId: PropTypes.string,
    daysLeft: PropTypes.number,
  }).isRequired,
  link: PropTypes.string,
  linkParams: PropTypes.object,
  sent: PropTypes.string,
  top: PropTypes.string,
  topEmphasize: PropTypes.string,
};

SearchBoostNotification.defaultProps = {
  bottom: undefined,
  bottomEmphasize: undefined,
  buttonText: undefined,
  eventName: undefined,
  link: undefined,
  linkParams: undefined,
  sent: undefined,
  top: undefined,
  topEmphasize: undefined,
};

export default SearchBoostNotification;
